const PREFIX = "lumanova_updates_muted_login_v1:";
const memory = new Set();

export function announcementMuted(userId) {
  if (!userId) return false;
  const key = PREFIX + userId;
  try { return window.localStorage.getItem(key) === "1" || memory.has(key); }
  catch { return memory.has(key); }
}

export function muteAnnouncements(userId) {
  if (!userId) return;
  const key = PREFIX + userId;
  memory.add(key);
  try { window.localStorage.setItem(key, "1"); } catch { /* Storage may be disabled. */ }
}

export function clearAnnouncementPreferences() {
  memory.clear();
  try {
    Object.keys(window.localStorage).filter((key) => key.startsWith(PREFIX))
      .forEach((key) => window.localStorage.removeItem(key));
  } catch { /* The in-memory preference has already been cleared. */ }
}
